import React from 'react';
import {Navigate, Route, Routes } from 'react-router-dom';
import {
    routes,
    routesPrefix,
} from "./routes/enums";
import * as Sentry from "@sentry/react";
import ProtectoraDetailPage from "@/modules/Protectora/views/ProtectoraDetailPage";

export function renderRoutesProtectora(props) {
    return (
        <Route path={routesPrefix.protectoraRoot} /*element={<DefaultLayout/>}*/>
            <Route exac path={routes.protectoraId} element={<ProtectoraDetailPage/>}/>
            <Route path='*' element={<Navigate to={"/"} />} />
        </Route>
    );
}

export function onChangeLocation(location) {
    try {

    } catch (e) {
        Sentry.captureException(e);
    }
}
